import AudioVisualizer3BarWaves from "./AudioVisualizer3BarWaves"
import AudioVisualizerVolumeBar from "./AudioVisualizerVolumeBar"
import AudioVisualizerMicFiller from "./AudioVisualizerMicFiller"

const AudioVisualizer = ( { audioTrack, type = "3barwave", size = 25, frameColor } ) => {
    if ( type === "3barwave" ) return <AudioVisualizer3BarWaves frameColor={frameColor} audioTrack={audioTrack} size={size} />
    if ( type === "volumebar" ) return <AudioVisualizerVolumeBar audioTrack={audioTrack} width={100} height={5} />
    if ( type === "micfiller" ) return <AudioVisualizerMicFiller frameColor={frameColor} audioTrack={audioTrack} size={size} />
    return null
}

export default AudioVisualizer
